import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 21 21"
    {...props}
  >
    <path d="M2.74 7.73a1.878 1.878 0 0 1 3.757 0v7.393a1.878 1.878 0 1 1-3.757 0zm5.635 3.345a1.878 1.878 0 1 1 3.756 0v4.048a1.878 1.878 0 0 1-3.756 0zM14.01 5.5a1.878 1.878 0 0 1 3.756 0v9.623a1.878 1.878 0 1 1-3.757 0V5.5Z" />
  </svg>
);
export default SvgLogs;
